import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '../products.config';

export const ANIMAL = {
  nickname: 'PRODUCTS.ANIMAL.shortname',
  propertiesProductsList: {
    name: 'animalList',
    properties: [
      { name: 'animalBreed', key: 'ANIMAL_BREED', group: 'INSURANCE_INFO' },
      { name: 'animalBreedType', key: 'ANIMAL_BREED_TYPE', group: 'INSURANCE_INFO' },
      { name: 'animalType', key: 'ANIMAL_TYPE', group: 'INSURANCE_INFO' },
      { name: 'animalSIIllness', key: 'ANIMAL_ILLNESS_SCOOPR', group: 'INSURANCE_INFO' },
      { name: 'animalDeathCoverage', key: 'ANIMAL_DEATH_COVERAGE', group: 'INSURANCE_INFO' },
      { name: 'animalSIDeath', key: 'ANIMAL_DEATH_SCOOPR', group: 'INSURANCE_INFO' },
      { name: 'animalBirthYear', key: 'ANIMAL_BIRTH_YEAR', group: 'OBJECT_INFO' }
    ]
  },
  properties: [
    {
      name: 'animalName', key: 'ANIMAL_NAME', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.STRING,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'animalType', key: 'ANIMAL_TYPE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED.CAT', value: 'CAT' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED.DOG', value: 'DOG' }
        ]
      }
    },
    {
      name: 'animalBirthDay', key: 'ANIMAL_BIRTH_DATE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.DATE,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        dateView: 'month'
      }
    },
    {
      name: 'calculatedAnimalAge', key: 'ANIMAL_AGE', group: 'OBJECT_INFO',
      // inputType: INPUT_TYPES_CONFIG.NUMBER,
      // validator: ['', [
      //   Validators.required
      // ]]
    },
    {
      name: 'animalSIIllness', key: 'ANIMAL_ILLNESS_SUM', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.NUMBER,
      ANIMAL_ILLNESS_SUM_INSURED_RANGE: true,
      validator: ['', [
        Validators.required,
        Validators.pattern(/^\d+$/),
        Validators.min(5000),
        Validators.max(50000)
      ]]
    },
    {
      name: 'animalLivestockMarkingMembership', key: 'ANIMAL_LIVESTOCK_MARKING_MEMBERSHIP', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.ANIMAL_LIVESTOCK_MARKING_MEMBERSHIP.LIVESTOCK_ID_MARKING', value: 'LIVESTOCK_ID_MARKING' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.ANIMAL_LIVESTOCK_MARKING_MEMBERSHIP.LIVESTOCK_MEMBER_NKK', value: 'LIVESTOCK_MEMBER_NKK' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.ANIMAL_LIVESTOCK_MARKING_MEMBERSHIP.NONE', value: 'NONE' }
        ]
      }
    },
    {
      name: 'animalId', key: 'ANIMAL_ID', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.TEL,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'animalBreed', key: 'ANIMAL_BREED', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_SEARCH_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: []
      },
      customValueConfig: {
        CAT: {
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_CAT.OTHER', value: 'Annen' },
            ]
          }
        },
        DOG: {
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.OTHER', value: 'Annen' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.BASENJI', value: 'Basenji' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.BASSET_HOUND', value: 'Bassethund' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.BERNER_SENNENHUND', value: 'Berner sennenhund' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.BOXER', value: 'Boxer' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.COCKER_SPANIEL', value: 'Cocker Spaniel' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.COLLIE', value: 'Collie' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.DALMATINER', value: 'Dalmatiner' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.DOBERMANN', value: 'Dobermann' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.DOGUE_DE_BORDEAUX', value: 'Dogue de Bordaux' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.ENGELSK_BULLDOG', value: 'Engelsk buldog' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.FRANSK_BULLDOG', value: 'Fransk bulldog' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.GRAND_DANIOS', value: 'Grand danios' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.IRSK_ULVEHUND', value: 'Irsk ulvehund' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.JAPANSK_CHIN', value: 'Japansk Chin' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.LANGHARRET_COLLIE', value: 'Langhåret collie' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.LEONBERGER', value: 'Leonberger' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.MASTIFF', value: 'Mastiff' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.NEAPOLITANSK_MASTIFF', value: 'Neapolitansk Mastiff' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.NEWFOUNDLANDSHUND', value: 'Newfoundlandshund' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.POCKET_BEAGLE', value: 'Pocket Beagle' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.SANKT_BERNHARDSHUND', value: 'Sankt bernhardshund' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.SCHAFERHUND', value: 'Schaferhund' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.SHAR_PEI', value: 'Shar Pei' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.KLEINSPITZ', value: 'Kleinspitz' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.STAFFORDSHIRE_BULL_TERRIER', value: 'Staffordshire bull terrrier' }
            ]
          }
        }
      }
    },
    {
      name: 'animalBreedType', key: 'ANIMAL_BREED_TYPE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.ANIMAL_BREED_TYPE.PUREBRED', value: 'PUREBRED' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.ANIMAL_BREED_TYPE.MIXED_BREED', value: 'MIXED_BREED' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.ANIMAL_BREED_TYPE.UNKNOWN', value: 'UNKNOWN' }
        ]
      }
    },
    {
      name: 'animalDeathCoverage', key: 'ANIMAL_DEATH_COVERAGE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      isAnimalDeathCoverageCheck: true,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'animalSIDeath', key: 'ANIMAL_DEATH_SUM', group: 'INSURANCE_INFO',
    },
  ],
  icon: 'animal'
};
